import { graphqlRequest } from "../graphqlClient";
import type {
	ForecastTransactionViewConnection,
	ForecastTransactionViewFilterInput,
} from "../models/forecastTransactionView";

export interface ForecastTransactionViewSortInput {
	field: string;
	order: "Ascending" | "Descending";
}

interface ForecastTransactionViewListResponse {
	transactions: {
		forecastTransactionViewList: ForecastTransactionViewConnection;
	};
}

export async function getForecastTransactionsGraphql(
	filter?: ForecastTransactionViewFilterInput,
	first?: number,
	after?: string,
	sort?: ForecastTransactionViewSortInput[],
): Promise<ForecastTransactionViewConnection> {
	const query = `
    query ForecastTransactionViewList($filter: ForecastTransactionViewFilterInput, $first: Int, $after: String, $sort: [ForecastTransactionViewSortSortByInput!]) {
      transactions {
        forecastTransactionViewList(filter: $filter, first: $first, after: $after, sort: $sort) {
          edges {
            cursor
            node {
              id
              forecastDate
              dueDate
              counterpartyName
              description
              category
              direction
              type
              grossAmount
              outstandingAmount
              layer
              status
              reference
              sourceId
              dataSourceName
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
      }
    }
  `;
	const data = await graphqlRequest<ForecastTransactionViewListResponse>(
		query,
		{
			filter,
			first,
			after,
			sort,
		},
	);
	return data.transactions.forecastTransactionViewList;
}

interface ForecastTransactionViewCountResponse {
	transactions: {
		forecastTransactionViewCount: number;
	};
}

export async function getForecastTransactionsCount(
	filter?: ForecastTransactionViewFilterInput,
): Promise<number> {
	const query = `
    query ForecastTransactionViewCount($filter: ForecastTransactionViewFilterInput) {
      transactions {
        forecastTransactionViewCount(filter: $filter)
      }
    }
  `;
	const data = await graphqlRequest<ForecastTransactionViewCountResponse>(
		query,
		{
			filter,
		},
	);
	return data.transactions.forecastTransactionViewCount;
}

interface ForecastTransactionViewDistinctValuesResponse {
	transactions: {
		forecastTransactionViewDistinctValues: string[];
	};
}

export async function getForecastTransactionDistinctValues(
	field: string,
): Promise<string[]> {
	const query = `
    query ForecastTransactionViewDistinctValues($field: String!) {
      transactions {
        forecastTransactionViewDistinctValues(field: $field)
      }
    }
  `;
	const data =
		await graphqlRequest<ForecastTransactionViewDistinctValuesResponse>(query, {
			field,
		});
	return data.transactions.forecastTransactionViewDistinctValues;
}
